<template lang="pug">
div
  .mt-7.pb-md-4
    .text-h6.text-decoration-none.font-weight-bold.text-md-h2.mb-6 {{ $t("партнеры") }}
      v-icon.ml-1.icon-large mdi-chevron-right
    div.mt-3
      div.slide-group__wrapper#partners-slider
        div.slide-group__content
          div(v-for="(partner, index) in partners" :key="index")
            v-card.partner-card.mr-2.pa-3.rounded-md.pa-md-6.mr-md-4(rounded="xl" outlined @click="navigateTo(partner.location, partner.tileName, false)")
              v-img.partner-icon.mb-4.mb-md-6(eager :src="`/static/${partner.icon}`")
              p.font-weight-bold.custom-title {{ partner.title }}
              p.pa-0.custom-subtitle.mt-2 {{ partner.subtitle }}
</template>

<script>
import { mapActions } from 'vuex'
import store from '../../../store/index'
import { getLocale } from '../../../i18n/index'

export default {
  data: (vm) => ({
    slider: null,
    isDown: false,
    startX: null,
    scrollLeft: null,
    velX: 0,
    momentumID: null,

    partners: [
      {
        title: vm.$t('halyk_для_бизнеса'),
        subtitle: vm.$t('суперприложение_для_вашего_бизнеса'),
        icon: 'halyk-business-partners.png',
        location: `https://onboard.${vm.$isTestMode() ? 'test.' : ''}onlinebank.kz/entry?client_id=rekassa_ip&phone_number=${store.state.auth.user.phone.replace('+7', '')}&lang=${getLocale() === 'kk' ? 'kaz' : 'rus'}&redirect_url=${import.meta.env.VITE_API_ROOT_URL}/main`,
        tileName: 'halykBusiness',
      },
      {
        title: 'Halyk Pos',
        subtitle: vm.$t('pos_терминал_с_онлайн_кассой'),
        icon: 'halyk-pos-partners.png',
        location: `https://rekassa.kz/${getLocale() === 'kk' ? 'kz' : 'ru'}/pos-terminal-plus-rekassa?utm_source=app&utm_medium=banner&utm_campaign=banner1`,
        tileName: 'halykPos',
      },
      {
        title: vm.$t('ваш_онлайн_магазин'),
        subtitle: vm.$t('начните_продавать_за_5_минут'),
        icon: 'halyk-market-partners.png',
        location: 'https://b2b.halykmarket.kz/?utm_source=rekassa&utm_medium=referral&utm_campaign=b2b_banner',
        tileName: 'halykMarket',
      },
      {
        title: 'hh бизнес',
        subtitle: vm.$t('поиск_сотрудников'),
        icon: 'hh-partners.png',
        location: 'https://hhlink-b2b.onelink.me/KZyE/lwoxwvz1',
        tileName: 'hhBusiness',
      },
      {
        title: 'МойСклад',
        subtitle: vm.$t('торговля_склад_CRM_в_облаке'),
        icon: 'moy-sklad-partners.png',
        location: `https://link.rekassa.kz/moi-sklad-about-${getLocale()}`,
        tileName: 'moySklad',
      },
      {
        title: '1С',
        subtitle: vm.$t('ведение_продаж_из_1с'),
        icon: '1c-partners.png',
        location: `https://link.rekassa.kz/1c-about-${getLocale()}`,
        tileName: 'halykPos',
      },
      {
        title: 'Мой учет.kz',
        subtitle: vm.$t('онлайн_бухгалтерия'),
        icon: 'moy-uchet-partners.png',
        location: '/kkm/moyuchet',
        tileName: 'moyUchet',
      },
    ],
  }),

  mounted() {
    this.mouseScrollInit()
  },

  methods: {
    ...mapActions({
      analyticsLogEvent: 'analytics/logEvent',
    }),

    navigateTo(location, tileName, byPass) {
      const partnersSlider = document.querySelector('#partners-slider')
      if (byPass || partnersSlider.getAttribute('data-slide-dragging') === 'false') {
        if (location.includes('http')) {
          this.$openLink(location, '_system')
        } else {
          this.$router.push(location)
        }
        this.analyticsLogEvent({ eventName: 're_dash_tile_clicked', eventProperties: { tile_name: tileName } })
      }
    },

    mouseScrollInit() {
      this.slider = document.querySelector('#partners-slider')

      this.slider.addEventListener('mousedown', (e) => {
        this.isDown = true
        this.slider.setAttribute('data-slide-dragging', 'false')
        this.startX = e.pageX - this.slider.offsetLeft
        this.scrollLeft = this.slider.scrollLeft
        this.cancelMomentumTracking()
      })

      this.slider.addEventListener('mouseleave', () => {
        this.isDown = false
      })

      this.slider.addEventListener('mouseup', () => {
        this.isDown = false
        this.beginMomentumTracking()
      })

      this.slider.addEventListener('mousemove', (e) => {
        if (!this.isDown) return
        e.preventDefault()
        const x = e.pageX - this.slider.offsetLeft
        const walk = x - this.startX
        if (walk !== 0) this.slider.setAttribute('data-slide-dragging', 'true')
        const prevScrollLeft = this.slider.scrollLeft
        this.slider.scrollLeft = this.scrollLeft - walk
        this.velX = this.slider.scrollLeft - prevScrollLeft
      })

      this.slider.addEventListener('wheel', () => {
        this.cancelMomentumTracking()
      })
    },

    beginMomentumTracking() {
      this.cancelMomentumTracking()
      this.momentumID = requestAnimationFrame(this.momentumLoop)
    },

    cancelMomentumTracking() {
      cancelAnimationFrame(this.momentumID)
    },

    momentumLoop() {
      if (!this.slider) return
      this.slider.scrollLeft += this.velX
      this.velX *= 0.95
      if (Math.abs(this.velX) > 0.5) {
        this.momentumID = requestAnimationFrame(this.momentumLoop)
      }
    },
  },
}
</script>

<style scoped lang="stylus">
.icon-large
  font-size 24px
  @media (min-width: 960px)
    font-size 32px

.partner-card
  width 160px
  height 160px
  @media (min-width: 960px)
    width 288px
    height 264px

.market-card
  width 180px
  height 140px
  @media (min-width: 960px)
    width 282px
    height 212px

.partner-icon
  width 40px
  height 40px
  @media (min-width: 960px)
    width 72px
    height 72px

.market-icon
  width 40px
  height 40px
  @media (min-width: 960px)
    width 72px
    height 72px

.custom-title
  font-size 1rem
  line-height 1.125rem
  @media screen and (min-width: 960px)
    font-size 1.375rem
    line-height 1.625rem

.custom-subtitle
  font-size 0.8125rem
  line-height 1rem
  @media screen and (min-width: 960px)
    font-size 1rem
    line-height 22px

.slide-group__wrapper
  overflow-x auto
  overflow-y hidden
  -ms-overflow-style none
  scrollbar-width none
  contain content
  display flex
  flex 1 1 auto

.slide-group__wrapper::-webkit-scrollbar
  display none
  width 0
  background transparent

.slide-group__content
  display flex
  flex 1 0 auto
  position relative
  transition 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)
  white-space nowrap
</style>
